import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ArrowRightMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M17.172 11l-5.364-5.364 1.414-1.414L21 12l-7.778 7.778-1.414-1.414L17.172 13H3v-2h14.172z"  /></Svg>;
}
export default ArrowRightMedium;